import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'htmlContent',
  standalone: true
})
export class HtmlContentPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(html: string | null | undefined): SafeHtml {
    if (!html) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    this.removeDangerousElements(doc.body);

    const sanitizedContent = doc.body.innerHTML;

    // I really, really want to avoid using bypassSecurityTrustHtml here,
    // but I couldn't find a way to display the HTML created by the
    // wysiwyg editor without it. I tried to sanitize it as much as possible first.
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
  }

  private removeDangerousElements(element: HTMLElement): void {
    const scripts = element.querySelectorAll('script');
    scripts.forEach(script => script.remove());

    // Handle all elements to remove dangerous attributes but keep style attributes
    const allElements = element.querySelectorAll('*');

    allElements.forEach(el => {
      // Remove all event handler attributes (onclick, onmouseover, etc.)
      Array.from(el.attributes).forEach(attr => {
        if (attr.name.startsWith('on')) {
          el.removeAttribute(attr.name);
        }
      });
    });
  }
}
